import { AxiosError } from 'axios';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const errorInterceptor = (error: AxiosError) => {
    if (error.message === 'Network Error') {
        return Promise.reject(new Error('Connection Error : + ' + error));
    }

    if (error.response?.status === 401) {
        //redirect to login
    }
    return Promise.reject(error);
};